<div>
  <div class="content-wrapper">
    <h2>Twoja sesja wygaśnie</h2>

    <p>Brak aktywności w systemie. Po upływie <span>{{ counter }}s</span> zostaniesz automatycznie wylogowany</p>
  </div>

  <div class="actions-wrapper">
<!--    <ds-button (onClick)="closeDialog(true)" label="Przedłuż sesję"></ds-button>-->
<!--    <ds-button (onClick)="closeDialog(false)" label="Wyloguj"></ds-button>-->
  </div>
</div>
